import moment from 'moment'
import { Expose, Transform, Type } from 'class-transformer'
import { List } from 'react-feather'

import { Address } from './Address'
import { Base } from './Base'
import { Client } from './Client'
import { CustomFieldValue } from './CustomFieldValue'
import { Facility } from './Facility'
import { Flag } from './Flag'

export class Order extends Base {
  static type = 'order'
  static typeDisplay = 'Order'
  static icon = List

  type = Order.type
  typeDisplay = Order.typeDisplay
  icon = Order.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  number?: string

  details?: string

  name: string = ''

  @Type(() => Client)
  client?: Client

  consignee?: string

  @Expose({ name: 'custom_fields' })
  @Type(() => CustomFieldValue)
  customFields?: CustomFieldValue[]

  status?: string

  @Type(() => Address)
  address?: Address

  @Expose({ name: 'placed_on' })
  @Transform((value) => moment(value))
  placedOn?: moment.Moment

  @Expose({ name: 'fulfill_by' })
  @Transform((value) => moment(value))
  fulfillBy?: moment.Moment

  facilities?: Facility[]

  @Type(() => Flag)
  flags?: Flag[]
}

export enum OrderStatusEnum {
  received = 'received',
  processing = 'processing',
  processed = 'processed',
  shipped = 'shipped',
  delivered = 'delivered',
  canceled = 'canceled',
}

export const orderStatusToString = (status: OrderStatusEnum): string => {
  return status[0].toUpperCase() + status.slice(1)
}

export const nextOrderStatus = (actualStatus: string) => {
  switch (actualStatus) {
    case 'received':
      return OrderStatusEnum.processing
    case 'processing':
      return OrderStatusEnum.processed
    case 'processed':
      return OrderStatusEnum.shipped
    case 'shipped':
      return OrderStatusEnum.delivered
    default:
      return actualStatus
  }
}
